<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ActiveFilterChip from './Filters/v3/ActiveFilterChip.vue';

const props = defineProps({
  agentId: { type: Number, default: null },
  teamId: { type: Number, default: null },
  inboxId: { type: Number, default: null },
  agents: { type: Array, default: () => [] },
  teams: { type: Array, default: () => [] },
  inboxes: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['filterChange']);
const { t } = useI18n();
const activeFilterType = ref('');

const filterDefinitions = computed(() => [
  {
    type: 'agent',
    id: props.agentId,
    label: t('REPORT.SCOPE_FILTERS.AGENT'),
    placeholder: t('REPORT.SCOPE_FILTERS.SEARCH_AGENT'),
    options: props.agents,
  },
  {
    type: 'team',
    id: props.teamId,
    label: t('REPORT.SCOPE_FILTERS.TEAM'),
    placeholder: t('REPORT.SCOPE_FILTERS.SEARCH_TEAM'),
    options: props.teams,
  },
  {
    type: 'inbox',
    id: props.inboxId,
    label: t('REPORT.SCOPE_FILTERS.INBOX'),
    placeholder: t('REPORT.SCOPE_FILTERS.SEARCH_INBOX'),
    options: props.inboxes,
  },
]);

const optionList = definition =>
  definition.options.map(item => ({
    id: item.id,
    name: item.name,
    type: definition.type,
  }));

const selectedName = definition =>
  definition.options.find(item => item.id === definition.id)?.name ||
  definition.label;

const currentFilters = () => ({
  agentId: props.agentId,
  teamId: props.teamId,
  inboxId: props.inboxId,
});

const openFilter = type => {
  activeFilterType.value = activeFilterType.value === type ? '' : type;
};

const closeFilter = () => {
  activeFilterType.value = '';
};

const updateFilter = (type, id) => {
  const filters = currentFilters();
  filters[`${type}Id`] = id;
  closeFilter();
  emit('filterChange', filters);
};
</script>

<template>
  <div
    class="flex flex-wrap items-center gap-2"
    :class="{ 'pointer-events-none opacity-50': disabled }"
  >
    <ActiveFilterChip
      v-for="definition in filterDefinitions"
      :id="definition.id"
      :key="definition.type"
      :name="selectedName(definition)"
      :type="definition.type"
      :options="optionList(definition)"
      :active-filter-type="activeFilterType"
      :show-menu="activeFilterType === definition.type"
      :placeholder="definition.placeholder"
      enable-search
      @toggle-dropdown="openFilter"
      @close-dropdown="closeFilter"
      @add-filter="updateFilter(definition.type, $event.id)"
      @remove-filter="updateFilter(definition.type, null)"
    />
  </div>
</template>
